import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GrayFade from '../../../../../GrayFade/GrayFade';
import StyledBodySpecialGridPrimaryColumn from '../StyledBodySpecialGridPrimaryColumn';
import BodySpecialAccordionContentList from '../BodySpecialAccordionContentList';
import IISA315ItControlsItem from './ISA315ItControlsItem';

const ISA315ItRiskAccordionControlsItem = ({itControlId, onEditITControl, engagementId}) => {
	const itControl = useSelector((state) => state.bodiesSpecial.itControls?.byId[itControlId]);
	const [isLoading, setIsLoading] = useState(false);

	const setLoading = (val) => {
		setIsLoading(val);
	};

	const onEditITControlClick = () => {
		onEditITControl({
			entityUId: itControlId,
			entityName: itControl.itControlName,
			itApproachTypeId: itControl.itApproachTypeId
		});
	};
	const firstColumnValue = React.useMemo(() => {
		return <IISA315ItControlsItem.itControlName itControlName={itControl.itControlName} />;
	}, [itControl]);

	const secondColumnValue = React.useMemo(() => {
		return (
			<IISA315ItControlsItem.itControlDesignEffectivenessType
				itControlEffectivenessTypeId={itControl.controlDesignEffectivenessTypeId}
			/>
		);
	}, [itControl]);

	const thirdColumnValue = React.useMemo(() => {
		return (
			<IISA315ItControlsItem.itControlTesting
				itControl={itControl}
				engagementId={engagementId}
				setIsLoading={setLoading}
			/>
		);
	}, [itControl]);

	const columnvalues = React.useMemo(() => {
		return [
			{
				title: firstColumnValue,
				className: 'isa315-itControl-itgc-item__first_column_value',
				onClick: onEditITControlClick
			},
			{title: secondColumnValue, className: 'isa315-itControl-itgc-item__second_column_value'},
			{title: thirdColumnValue, className: 'isa315-itControl-itgc-item__third_column_value'}
		];
	}, [itControl]);

	return (
		<StyledControlName className="StyledControlName">
			<GrayFade isGrayFade={isLoading}>
				{itControl && <BodySpecialAccordionContentList columns={columnvalues} />}
			</GrayFade>
		</StyledControlName>
	);
};

ISA315ItRiskAccordionControlsItem.propTypes = {
	itControlId: PropTypes.number,
	onEditITControl: PropTypes.func.isRequired
};

export default ISA315ItRiskAccordionControlsItem;

const StyledControlName = styled(StyledBodySpecialGridPrimaryColumn)`
	width: 100%;
	.StyledBodySpecialAccordionContentList {
		padding: var(--px-15) 0 0 0;
		.body-special-accordion-content-list-header {
			display: flex;
			border: 0;
		}
	}
	.isa315-itControl-itgc-item__first_column_value {
		width: 70%;
		padding-right: var(--px-40);
		padding-bottom: var(--px-10);
		margin-left: var(--px-20);
		display: inline-flex;
		border-bottom: var(--px-1) solid var(--neutrals-200);
		&:hover {
			text-decoration: underline;
		}
	}
	.isa315-itControl-itgc-item__second_column_value {
		width: 20%;
		display: inline-flex;
		border-bottom: var(--px-1) solid var(--neutrals-200);
	}
	.isa315-itControl-itgc-item__third_column_value {
		width: 10%;
		display: inline-flex;
		border-bottom: var(--px-1) solid var(--neutrals-200);
	}
`;

const StyledLoadingWrapper = styled.div`
	border-bottom: var(--px-1) solid var(--neutrals-200);
	padding-right: var(--px-20);
	margin: 0 var(--px-20);
	.MotifProgressBarLabel {
		font-size: var(--px-10);
		margin-bottom: var(--px-5);
		color: var(--neutrals-1000);
	}
`;
